// extracted by mini-css-extract-plugin
export default {"catalogSkelletonsContainer":"CatalogSkelleton_catalogSkelletonsContainer__IB40X","catalogSkelleton":"CatalogSkelleton_catalogSkelleton__tUgbd"};